import { render, staticRenderFns } from "./ComponentLargeVolume.vue?vue&type=template&id=0ca2bf3c"
import script from "./ComponentLargeVolume.vue?vue&type=script&lang=js"
export * from "./ComponentLargeVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports